export const checkboxPaymentState = 'checkboxPaymentState';
export const terminalPayment = 'terminalPayment';
